import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SecurityService } from '@bayclubs/utils';

@Injectable({
    providedIn: 'root'
})
export class SecuritySignalService {
    private readonly securityService = inject(SecurityService);

    readonly canManageClasses = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canManageClasses'),
        { initialValue: false }
    );

    readonly canManagePlaylists = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canManagePlaylists'),
    );

    readonly canManageProviders = toSignal(
        this.securityService.hasPrivilege('Providers', 'canManageProviders'),
        { initialValue: false }
    );

    readonly canManageRecordedClass = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canManageRecordedClass'),
    );

    readonly canViewClasses = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canViewClasses'),
        { initialValue: false }
    );

    readonly canViewRecordedClass = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canViewRecordedClass'),
        { initialValue: false }
    );

    readonly canViewPlaylists = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canViewPlaylists'),
        { initialValue: false }
    );

    readonly canViewReports = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canViewReports'),
        { initialValue: false }
    );

    readonly canViewClubs = toSignal(
        this.securityService.hasPrivilege('GroupClasses', 'canViewClubs'),
        { initialValue: false }
    );

    readonly canViewSubstitutionRequests = toSignal(
        this.securityService.hasPrivilege('SubBoard', 'canViewSubstitutionRequests'),
        { initialValue: false }
    );
}
